import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  Box,
  Flex,
  Input,
  InputGroup,
  InputRightElement,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Thead,
  Tr,
  HStack,
  Img,
  Button,
  Image,
  MenuItem,
  MenuList,
  MenuButton,
  Menu,
  useDisclosure,
  Skeleton,
  Checkbox,
  useClipboard,
} from "@chakra-ui/react";
import { ChevronDownIcon, CopyIcon, SearchIcon } from "@chakra-ui/icons";
import { formatTableValue } from "./formatTable";
import { formatNumber } from "../../utils/utils";
import chevronLeft from "../../assets/images/employee/chevron-left.svg";
import chevronRight from "../../assets/images/employee/chevron-right.svg";
import useDebounce from "../../hooks/useDebounce";
import ReactPaginate from "react-paginate";
import iconDetail from "../../assets/images/contract/Frame (1).svg";
import { AiOutlineMore } from "react-icons/ai";
import SearchableSelect from "../../components/selectForm";
import FormDetail from "./form/detail";
import FormInfo from "./form/info";
import FormProvisionalInfo from "./form/provisionalInfo";
import { useCategories } from "../../categorys/locking/index";
import toast from "react-hot-toast";
import { lockingCall } from "../../api/locking";
import { lockingImageCall } from "../../api/lockingImage";
import { lockingParticipantCall } from "../../api/lockingParticipant";
import SearchableSelectMulti from "../../components/selectForm/mutiSelect";
import DatePicker from "react-datepicker";
import calendarIcon from "../../assets/images/onleave/calendar.svg";
import { useServiceFeeManagement } from "../../hooks/useServiceFeeManagement";
import { useNavigate } from "react-router-dom";
import icontrash from "../../assets/images/product/trash.svg";
import DeleteDialog from "../../components/dialog/delete";
import ColumnFilterRow from "../../components/table/columnFilterRow";

const TableLocking = ({ isRefetchingWithCreate, paramData }) => {
  const { isOpen, onOpen, onClose, onToggle } = useDisclosure();
  const {
    isOpen: isOpenProvisionalInfo,
    onOpen: onOpenProvisionalInfo,
    onClose: onCloseProvisionalInfo,
    onToggle: onToggleProvisionalInfo,
  } = useDisclosure();
  const {
    isOpen: isOpenCloseAll,
    onOpen: onOpenCloseAll,
    onClose: onCloseCloseAll,
    onToggle: onToggleCloseAll,
  } = useDisclosure();
  const {
    isOpen: isOpenInfoAll,
    onOpen: onOpenInfoAll,
    onClose: onCloseInfoAll,
    onToggle: onToggleInfoAll,
  } = useDisclosure();
  const {
    isOpen: isOpenMessage,
    onOpen: onOpenMessage,
    onClose: onCloseMessage,
  } = useDisclosure();
  const {
    isOpen: isOpenisOpenTPDV,
    onOpen: onOpenTPDV,
    onClose: onCloseTPDV,
    onToggle: onToggleTPDV,
  } = useDisclosure();

  const [search, setSearch] = useState("");
  const [minPrice, setMinPrice] = useState("");
  const [maxPrice, setMaxPrice] = useState("");
  const [saleEmployeeId, setSaleEmployeeId] = useState(null);
  const [dateRangeTtkq, setDateRangeTtkq] = useState([null, null]);
  const [startDateTtkq, endDateTtkq] = dateRangeTtkq;
  const [dateRangeHdmb, setDateRangeHdmb] = useState([null, null]);
  const [startDateHdmb, endDateHdmb] = dateRangeHdmb;
  const [reconciliationMonthDate, setReconciliationMonthDate] = useState(null);
  const [isAddBooking, setIsAddBooking] = useState(false);
  const [projectId, setProjectId] = useState([]);
  const [saleOpeningEventId, setSaleOpeningEventId] = useState(null);
  const [customerId, setCustomerId] = useState(null);
  const [employeeId, setEmployeeId] = useState(null);
  const [dataEdit, setDataEdit] = useState(null);
  const [shouldFetch, setShouldFetch] = useState(false);
  const [status, setStatus] = useState(["APPROVED"]);
  const [isTtkqHdmbs, setIsTtkqHdmbs] = useState(null);
  const [apartmentId, setApartmentId] = useState([]);
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [saleBlockId, setSaleBlockId] = useState(null);
  const [saleAreaId, setSaleAreaId] = useState(null);
  const [startCalculate, setStartCalculate] = useState(null);
  const [approveTransaction, setApproveTransaction] = useState(null);
  const [dateRangeCreated, setDateRangeCreated] = useState([null, null]);
  const [startDateCreated, endDateCreated] = dateRangeCreated;
  const [inputLate, setInputLate] = useState(false);
  const [message, setMessage] = useState("");
  const [message2, setMessage2] = useState("");
  const { hasCopied, onCopy } = useClipboard(message);
  const { hasCopied2, onCopy2 } = useClipboard(message2);
  const [actionSelected, setActionSelected] = useState(1);

  //
  const [selectedValues, setSelectedValues] = useState([]);
  const [selectDeleteAll, setSelectDeleteAll] = useState([]);

  const debouncedSearchTerm = useDebounce(search, 500);
  const debouncedMinPrice = useDebounce(minPrice, 500);
  const debouncedMaxPrice = useDebounce(maxPrice, 500);

  const onChangeSearch = useCallback((e) => {
    const { value } = e.target;
    setSearch(value);
  }, []);

  const onChangeMinPrice = useCallback((e) => {
    const raw = e.target.value.replace(/[^0-9]/g, "");
    setMinPrice(raw);
  }, []);

  const onChangeMaxPrice = useCallback((e) => {
    const raw = e.target.value.replace(/[^0-9]/g, "");
    setMaxPrice(raw);
  }, []);

  const navigate = useNavigate();

  const {
    lockingManagementData,
    refetch,
    isLoading,
    isRefetching,
    totalPages,
    setCurrentPage,
    currentPage,
    entries,
    startEntry,
    endEntry,
  } = useServiceFeeManagement(
    debouncedSearchTerm,
    projectId,
    employeeId,
    null,
    status,
    isTtkqHdmbs,
    apartmentId,
    customerId,
    startDate,
    endDate,
    saleBlockId,
    saleAreaId,
    startDateCreated,
    endDateCreated,
    startCalculate,
    inputLate,
    approveTransaction,
    saleOpeningEventId,
    debouncedMinPrice,
    debouncedMaxPrice,
    saleEmployeeId,
    startDateTtkq,
    endDateTtkq,
    startDateHdmb,
    endDateHdmb,
    reconciliationMonthDate,
  );

  // refech create
  function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    }, [value]);
    return ref.current;
  }
  const prevIsRefetchingWithCreate = usePrevious(isRefetchingWithCreate);

  useEffect(() => {
    if (
      isRefetchingWithCreate &&
      prevIsRefetchingWithCreate !== isRefetchingWithCreate
    ) {
      refetch();
    }
  }, [isRefetchingWithCreate, prevIsRefetchingWithCreate, refetch]);

  useEffect(() => {
    paramData({
      search: debouncedSearchTerm,
      projectId,
      employeeId,
      lockingEventId: null,
      status,
      isTtkqHdmbs,
      apartmentId,
      customerId,
      startTime: startDate,
      endTime: endDate,
      saleBlockId,
      saleAreaId,
      startDateCreated,
      endDateCreated,
      startCalculate,
      inputLate,
      approveTransaction,
      minPriceOfCommission: debouncedMinPrice,
      maxPriceOfCommission: debouncedMaxPrice,
      saleEmployeeId,
      startTimeTtkq: startDateTtkq,
      endTimeTtkq: endDateTtkq,
      startTimeHdmb: startDateHdmb,
      endTimeHdmb: endDateHdmb,
      reconciliationMonthDate,
    });
  }, [
    paramData,
    debouncedSearchTerm,
    projectId,
    employeeId,
    null,
    status,
    isTtkqHdmbs,
    apartmentId,
    customerId,
    startDate,
    endDate,
    saleBlockId,
    saleAreaId,
    startDateCreated,
    endDateCreated,
    startCalculate,
    inputLate,
    approveTransaction,
    debouncedMinPrice,
    debouncedMaxPrice,
    saleEmployeeId,
    startDateTtkq,
    endDateTtkq,
    startDateHdmb,
    endDateHdmb,
    reconciliationMonthDate,
  ]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShouldFetch(true);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  const { constantData } = useCategories(null, null, 1, shouldFetch);

  const formatEntries = (entries) =>
    Object.entries(entries || {}).map(([key, value]) => ({ key, value }));

  const projects = useMemo(
    () => formatEntries(constantData?.project),
    [constantData?.project],
  );
  const employees = useMemo(
    () => formatEntries(constantData?.employee),
    [constantData?.employee],
  );
  const apartments = useMemo(
    () => formatEntries(constantData?.apartments),
    [constantData?.apartments],
  );
  const setSaleOpeningEvents = useMemo(
    () => formatEntries(constantData?.saleOpeningEvent),
    [constantData?.saleOpeningEvent],
  );
  const customers = useMemo(() => {
    if (!constantData?.customer) return [];

    return Object.entries(constantData.customer).map(
      ([id, { fullName, phone, identificationNumber }]) => ({
        key: id,
        value: `${fullName}`,
        phone,
        identificationNumber,
      }),
    );
  }, [constantData?.customer]);

  const saleAreas = useMemo(
    () => formatEntries(constantData?.saleArea),
    [constantData?.saleArea],
  );
  const saleBlocks = useMemo(
    () => formatEntries(constantData?.saleBlock),
    [constantData?.saleBlock],
  );

  const statusDatas = [
    {
      key: "NEW",
      value: "Chưa duyệt",
    },
    {
      key: "REJECTED",
      value: "Không được phê duyệt",
    },
    {
      key: "APPROVED",
      value: "Đã được duyệt",
    },
    {
      key: "REFUND",
      value: "Đã hoàn trả",
    },
    {
      key: "EDITING",
      value: "Yêu cầu chỉnh sửa",
    },
  ];

  const statusInputLate = [
    {
      key: 1,
      value: "Muộn",
    },
    {
      key: 2,
      value: "Chưa muộn",
    },
  ];

  const statusStartCalculateDatas = [
    {
      key: 1,
      value: "Đã bắt đầu đối chiếu",
    },
    {
      key: "2",
      value: "Chưa bắt đầu đối chiếu",
    },
  ];

  const approveTransactions = [
    {
      key: 1,
      value: "Đã duyệt bước 1",
    },
    {
      key: 2,
      value: "Đã duyệt bước 2",
    },
    {
      key: 3,
      value: "Đã duyệt bước 3",
    },
  ];

  const tableData = {
    headers: [
      {
        label: "",
        key: "",
      },
      {
        label: "STT",
        key: "",
      },
            {
        label: "Đợt đối chiếu", // new
        key: "stepCommission",
      },
      // {
      //   label: "Trạng thái",
      //   key: "status",
      // },
      {
        label: "Tính phí dịch vụ",
        key: "calculateServiceFees",
      },
      {
        label: "Nhập CTV muộn",
        key: "lateInput",
      },
      {
        label: "Trạng thái đối chiếu", // new
        key: "totalCommissionStatus",
      },
      {
        label: "Mã căn",
        key: "codeApartment",
      },
      {
        label: "Tên dự án",
        key: "nameProject",
      },
      {
        label: "Đợt mở bán", // new
        key: "nameSaleOpeningEvent",
      },
      {
        label: "Tên khách hàng",
        key: "nameCustomer",
      },
      {
        label: "Giá tính PDV tạm tính", // new
        key: "estimatePriceOfCommission",
      },
      {
        label: "Giá tính PDV ", // new
        key: "priceOfCommission",
      },
      {
        label: "Nhân viên tạo looking",
        key: "nameLocking",
      },
      {
        label: "Danh sách sale", // new
        key: "participantList",
      },
      {
        label: "Khối",
        key: "saleBlock",
      },
      {
        label: "Vùng",
        key: "saleArea",
      },
      //   {
      //     label: "Mã đợt mở bán",
      //     key: "saleOpeningEvent",
      //   },
      //   {
      //     label: "Mã booking",
      //     key: "booking",
      //   },
      //   {
      //     label: "Tên sản phẩm",
      //     key: "nameApartment",
      //   },
      //   {
      //     label: "Số tiền đặt cọc",
      //     key: "price",
      //   },
      //   {
      //     label: "Đại lý",
      //     key: "agentName",
      //   },
      {
        label: "Ngày đặt cọc",
        key: "bookingTime",
      },
      {
        label: "Thời gian tạo looking",
        key: "createdAt",
      },
      //   {
      //     label: "Ghi chú",
      //     key: "note",
      //   },

      {
        label: "Ngày ký TTKQ", // new
        key: "signingDateTTKQ",
      },
      {
        label: "Ngày ký HDBM", // new
        key: "signingDateHDBM",
      },
    ],
    data: lockingManagementData,
  };

  const filteredTableData = useMemo(
    () => ({
      ...tableData,
      data: Array.isArray(tableData?.data)
        ? tableData.data.filter(
            (item) => item,
            // item.registerRelativeStatus
          )
        : [],
    }),
    [tableData],
  );

  useEffect(() => {
    const isAllSelected =
      filteredTableData?.data?.length > 0 &&
      filteredTableData?.data?.every((item) =>
        selectedValues?.includes(item.id),
      );

    if (isAllSelected) {
      setSelectDeleteAll((prevDeleteAll = []) =>
        prevDeleteAll.includes(currentPage)
          ? prevDeleteAll
          : [...prevDeleteAll, currentPage],
      );
    }
  }, [selectedValues, filteredTableData, currentPage]);

  const handleCheckboxChange = (key) => {
    setSelectedValues((prev = []) => {
      if (prev.includes(key)) {
        setSelectDeleteAll((selectAll = []) => {
          return selectAll.includes(currentPage)
            ? selectAll.filter((item) => item !== currentPage)
            : selectAll;
        });
        return prev.filter((item) => item !== key);
      } else {
        return [...prev, key];
      }
    });
  };
  const handleCheckboxDeleteAll = (current) => {
    setSelectDeleteAll((prev) => {
      if (prev.includes(current)) {
        if (
          Array.isArray(filteredTableData?.data) &&
          filteredTableData?.data.length > 0
        ) {
          setSelectedValues((select) =>
            select.filter(
              (id) => !filteredTableData?.data.some((item) => item.id === id),
            ),
          );
        }
        return prev.filter((item) => item !== current);
      } else {
        if (
          Array.isArray(filteredTableData?.data) &&
          filteredTableData?.data.length > 0
        ) {
          setSelectedValues((select) => [
            ...new Set([
              ...select,
              ...filteredTableData?.data.map((item) => item.id),
            ]),
          ]);
        }
        return [...prev, current];
      }
    });
  };

  const handlePageChange = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1);
    refetch();
  };

  // table
  const handlePopup = (type, e) => {
    if (type) {
      setDataEdit(e?.edit);
    } else {
      setDataEdit(e?.detail);
    }

    setIsAddBooking(type);
    onOpen();
  };

  const handleProvisionalInfoPopup = (e) => {
    setDataEdit(e?.detail);

    setIsAddBooking(false);
    onOpenProvisionalInfo();
  };

  const handleNavigateCaculatePage = (id) => {
    navigate(`/locking/calculateServiceFees/${id}`);
  };

  const handleEdit = (type, e) => {
    setDataEdit(e?.detail);

    setIsAddBooking(type);
  };

  const onSubmitEdit = async (data) => {
    const toastCreate = toast.loading("Đang Sửa locking ...");
    try {
      let filteredData = Object.fromEntries(
        Object.entries(data).filter(
          ([_, value]) => value !== "" && value !== undefined && value !== null,
        ),
      );

      const { id, delegationImage, employeeProject, ...dataFilter } =
        filteredData;

      delete dataFilter?.delegationImage;
      delete dataFilter?.images;
      delete dataFilter?.errorImagePayment;
      delete dataFilter?.createdAt;

      if (id) {
        let createDataEmployeeManager = [];
        if (employeeProject) {
          createDataEmployeeManager = employeeProject.map((item) => {
            if (item?.id) {
              delete item?.id;
            }
            item.lockingId = id;
            return item;
          });
        }
        if (createDataEmployeeManager.length > 0) {
          await lockingParticipantCall.createAndUpdateMany({
            lockingId: id,
            list: createDataEmployeeManager,
          });
        }

        if (data?.delegationImage && data?.delegationImage.length > 0) {
          const paths = data?.delegationImage
            ?.filter((img) => img.path)
            .map((img) => img.path);

          await lockingImageCall.createMany({
            lockingId: id,
            path: paths,
            type: "TRANSACTION",
          });
        }
      }

      await lockingCall.update(id, {
        ...dataFilter,
      });

      await refetch();
      onToggle();
      onClose();
      toast.success("Sửa thành công");
    } catch (error) {
      console.log({ error });
      toast.dismiss(toastCreate);
    }
    toast.dismiss(toastCreate);
  };

  const onAppoveRegisterRelativeStatus = async () => {
    setActionSelected(1);
    onOpenCloseAll();
  };

  const onAppoveInfoStatus = async () => {
    setActionSelected(2);
    onOpenInfoAll();
  };

  const closeMessage = () => {
    setMessage("");
    setMessage2("");
    onCloseMessage();
  };

  const appoveRegisterRelativeStatusAll = async () => {
    if (Array.isArray(selectedValues) && selectedValues.length > 0) {
      const toastEdit = toast.loading("Đang duyệt dữ liệu ...");
      try {
        const data = await lockingCall.approveRegisterRelativeMany({
          data: selectedValues,
        });
        await refetch();
        setDataEdit(null);
        onCloseCloseAll();
        onToggleCloseAll();
        toast.success("Duyệt thành công");
        setSelectedValues([]);
        setSelectDeleteAll([]);

        if (data?.message) {
          setMessage(data?.message);
          onOpenMessage();
        }
      } catch (error) {
        console.error("Error:", error);
        toast.error("Có lỗi xảy ra khi duyệt");
      }
      toast.dismiss(toastEdit);
    } else {
      toast.error("Vui lòng chọn dữ liệu trước khi duyệt");
    }
  };

  const appovedInfoStatusAll = async () => {
    if (Array.isArray(selectedValues) && selectedValues.length > 0) {
      const toastEdit = toast.loading("Đang duyệt dữ liệu ...");
      try {
        const data = await lockingCall.approveInformationMany({
          data: selectedValues,
        });

        await refetch();
        setDataEdit(null);
        onCloseInfoAll();
        onToggleInfoAll();
        toast.success("Duyệt thành công");
        setSelectedValues([]);
        setSelectDeleteAll([]);

        if (data?.message) {
          setMessage(data?.message);
          onOpenMessage();
        }

        if (data?.message2) {
          setMessage2(data?.message2);
          onOpenMessage();
        }
      } catch (error) {
        console.error("Error:", error);
        toast.error("Có lỗi xảy ra khi duyệt");
      }
      toast.dismiss(toastEdit);
    } else {
      toast.error("Vui lòng chọn dữ liệu trước khi duyệt");
    }
  };

  const submitStatus = async (status, id) => {
    const toastEdit = toast.loading("Đang cập nhập trạng thái ...");
    const dataFormat = {
      status: status,
    };

    try {
      await lockingCall.approve(id, dataFormat);
      await refetch();
      toast.success("Cập nhập trạng thái thành công");
    } catch (error) {
      console.error("Error:", error);
      toast.error("Có lỗi xảy ra khi cập nhập trạng thái");
    }
    toast.dismiss(toastEdit);
  };

  const revertStatus = async (status, id) => {
    const toastEdit = toast.loading("Đang cập nhập trạng thái ...");
    const dataFormat = {
      status: status,
    };

    try {
      await lockingCall.revert(id, dataFormat);
      await refetch();
      toast.success("Cập nhập trạng thái thành công");
    } catch (error) {
      console.error("Error:", error);
      toast.error("Có lỗi xảy ra khi cập nhập trạng thái");
    }
    toast.dismiss(toastEdit);
  };

  // Giữ lựa chọn cho multi-select khi bảng bị remount trong Skeleton lúc refetch
  const selectedApartmentOptions = useMemo(
    () => apartments.filter((o) => (apartmentId || []).includes(o.key)),
    [apartments, apartmentId],
  );
  const selectedProjectOptions = useMemo(
    () => projects.filter((o) => (projectId || []).includes(o.key)),
    [projects, projectId],
  );

  // Bộ lọc hiển thị ngay dưới tiêu đề cột — tái sử dụng state/setter sẵn có,
  // không thay đổi logic lọc, chỉ đổi vị trí control.
  const priceRangeFilter = (
    <Flex alignItems={"center"} gap={"6px"}>
      <Input
        type="text"
        inputMode="numeric"
        placeholder="Từ"
        value={minPrice ? formatNumber(Number(minPrice)) : ""}
        onChange={onChangeMinPrice}
        w={"110px"}
        h={"44px"}
        border={"1px solid var(--Line)"}
        backgroundColor={"#FFF"}
        fontSize={"14px"}
        borderRadius={"8px"}
      />
      <Text fontSize={"14px"} color={"#000"} whiteSpace={"nowrap"}>
        -
      </Text>
      <Input
        type="text"
        inputMode="numeric"
        placeholder="Đến"
        value={maxPrice ? formatNumber(Number(maxPrice)) : ""}
        onChange={onChangeMaxPrice}
        w={"110px"}
        h={"44px"}
        border={"1px solid var(--Line)"}
        backgroundColor={"#FFF"}
        fontSize={"14px"}
        borderRadius={"8px"}
      />
    </Flex>
  );

  const columnFilters = {
    lateInput: (
      <SearchableSelect
        isShowSearch={false}
        options={statusInputLate}
        initialSelectedOption={{ key: null, value: "Tất cả" }}
        setValue={setInputLate}
        selectedKey={inputLate}
        width="100%"
        minW="170px"
      />
    ),
    totalCommissionStatus: (
      <SearchableSelect
        isShowSearch={true}
        options={statusStartCalculateDatas}
        initialSelectedOption={{ key: 0, value: "Tất cả" }}
        setValue={setStartCalculate}
        selectedKey={startCalculate}
        width="100%"
        minW="200px"
      />
    ),
    codeApartment: (
      <SearchableSelectMulti
        isShowSearch={true}
        options={apartments}
        initialSelectedOption={selectedApartmentOptions}
        placeholder={"Tất cả"}
        setValue={setApartmentId}
        width="100%"
        minW="150px"
      />
    ),
    nameProject: (
      <SearchableSelectMulti
        isShowSearch={true}
        options={projects}
        initialSelectedOption={selectedProjectOptions}
        placeholder={"Tất cả"}
        setValue={setProjectId}
        width="100%"
        minW="150px"
      />
    ),
    nameSaleOpeningEvent: (
      <SearchableSelect
        isShowSearch={true}
        options={setSaleOpeningEvents}
        initialSelectedOption={{ key: 0, value: "Tất cả" }}
        setValue={setSaleOpeningEventId}
        selectedKey={saleOpeningEventId}
        width="100%"
        minW="150px"
      />
    ),
    nameCustomer: (
      <SearchableSelect
        isShowSearch={true}
        options={customers}
        initialSelectedOption={{ key: 0, value: "Tất cả" }}
        setValue={setCustomerId}
        selectedKey={customerId}
        width="100%"
        minW="150px"
      />
    ),
    estimatePriceOfCommission: priceRangeFilter,
    priceOfCommission: priceRangeFilter,
    nameLocking: (
      <SearchableSelect
        isShowSearch={true}
        options={employees}
        initialSelectedOption={{ key: 0, value: "Tất cả" }}
        setValue={setEmployeeId}
        selectedKey={employeeId}
        width="100%"
        minW="170px"
      />
    ),
    participantList: (
      <SearchableSelect
        isShowSearch={true}
        options={employees}
        initialSelectedOption={{ key: 0, value: "Tất cả" }}
        setValue={setSaleEmployeeId}
        selectedKey={saleEmployeeId}
        width="100%"
        minW="170px"
      />
    ),
    saleBlock: (
      <SearchableSelect
        isShowSearch={true}
        options={saleBlocks}
        initialSelectedOption={{ key: 0, value: "Tất cả" }}
        setValue={setSaleBlockId}
        selectedKey={saleBlockId}
        width="100%"
        minW="150px"
      />
    ),
    saleArea: (
      <SearchableSelect
        isShowSearch={true}
        options={saleAreas}
        initialSelectedOption={{ key: 0, value: "Tất cả" }}
        setValue={setSaleAreaId}
        selectedKey={saleAreaId}
        width="100%"
        minW="150px"
      />
    ),
    bookingTime: (
      <InputGroup w={"100%"} minW={"230px"} maxW={"260px"}>
        <DatePicker
          selectsRange={true}
          startDate={startDate}
          endDate={endDate}
          dateFormat="dd/MM/yyyy"
          locale="vi"
          onChange={(update) => {
            setDateRange(update);
          }}
          isClearable={true}
          placeholderText="Từ ngày - đến ngày"
          className="datePickerStyle"
          popperProps={{ strategy: "fixed" }}
          portalId="datepicker-portal"
        />
        {!startDate && !endDate && (
          <InputRightElement pointerEvents="none" h={"44px"}>
            <Image src={calendarIcon} />
          </InputRightElement>
        )}
      </InputGroup>
    ),
    createdAt: (
      <InputGroup w={"100%"} minW={"230px"} maxW={"260px"}>
        <DatePicker
          selectsRange={true}
          startDate={startDateCreated}
          endDate={endDateCreated}
          dateFormat="dd/MM/yyyy"
          locale="vi"
          onChange={(update) => {
            setDateRangeCreated(update);
          }}
          isClearable={true}
          placeholderText="Từ ngày - đến ngày"
          className="datePickerStyle"
          popperProps={{ strategy: "fixed" }}
          portalId="datepicker-portal"
        />
        {!startDateCreated && !endDateCreated && (
          <InputRightElement pointerEvents="none" h={"44px"}>
            <Image src={calendarIcon} />
          </InputRightElement>
        )}
      </InputGroup>
    ),
    signingDateTTKQ: (
      <InputGroup w={"100%"} minW={"230px"} maxW={"260px"}>
        <DatePicker
          selectsRange={true}
          startDate={startDateTtkq}
          endDate={endDateTtkq}
          dateFormat="dd/MM/yyyy"
          locale="vi"
          onChange={(update) => {
            setDateRangeTtkq(update);
          }}
          isClearable={true}
          placeholderText="Từ ngày - đến ngày"
          className="datePickerStyle"
          popperProps={{ strategy: "fixed" }}
          portalId="datepicker-portal"
        />
        {!startDateTtkq && !endDateTtkq && (
          <InputRightElement pointerEvents="none" h={"44px"}>
            <Image src={calendarIcon} />
          </InputRightElement>
        )}
      </InputGroup>
    ),
    signingDateHDBM: (
      <InputGroup w={"100%"} minW={"230px"} maxW={"260px"}>
        <DatePicker
          selectsRange={true}
          startDate={startDateHdmb}
          endDate={endDateHdmb}
          dateFormat="dd/MM/yyyy"
          locale="vi"
          onChange={(update) => {
            setDateRangeHdmb(update);
          }}
          isClearable={true}
          placeholderText="Từ ngày - đến ngày"
          className="datePickerStyle"
          popperProps={{ strategy: "fixed" }}
          portalId="datepicker-portal"
        />
        {!startDateHdmb && !endDateHdmb && (
          <InputRightElement pointerEvents="none" h={"44px"}>
            <Image src={calendarIcon} />
          </InputRightElement>
        )}
      </InputGroup>
    ),
    stepCommission: (
      <InputGroup w={"100%"} minW={"170px"} maxW={"200px"}>
        <DatePicker
          selected={reconciliationMonthDate}
          onChange={(date) => {
            setReconciliationMonthDate(date);
          }}
          dateFormat="MM/yyyy"
          showMonthYearPicker
          locale="vi"
          isClearable={true}
          placeholderText="Tháng đối chiếu"
          className="datePickerStyle"
          popperProps={{ strategy: "fixed" }}
          portalId="datepicker-portal"
        />
        {!reconciliationMonthDate && (
          <InputRightElement pointerEvents="none" h={"44px"}>
            <Image src={calendarIcon} />
          </InputRightElement>
        )}
      </InputGroup>
    ),
  };

  return (
    <>
      <Flex flexDirection={"column"} gap={{ base: "16px" }}>
        <Flex
          backgroundColor="var(--color-main)"
          borderRadius={{ base: "12px" }}
          flexDirection={"column"}
        >
          <Flex
            alignItems={"center"}
            justifyContent={"space-between"}
            gap={{ base: "32px" }}
            p={"16px 16px 12px 16px"}
          >
            <Flex
              alignItems={"flex-start"}
              gap={{ base: "16px 32px" }}
              flex={"1"}
              flexDirection={"column"}
            >
              <InputGroup
                maxW="42vw"
                minW={"42vw"}
                borderRadius={{ base: "8px" }}
                w={{ base: "100%" }}
              >
                <Input
                  placeholder="Tên người tạo, khách hàng, sản phẩm, dự án "
                  type="text"
                  borderRadius={{ base: "8px" }}
                  border={{ base: "1px solid var(--color-boder)" }}
                  backgroundColor={"var(--fill-avatar)"}
                  onChange={onChangeSearch}
                />
                <InputRightElement
                  borderTopRightRadius={"8px"}
                  borderBottomRightRadius={"8px"}
                  pointerEvents="none"
                  cursor={"pointer"}
                  backgroundImage="var(--color-button)"
                >
                  <SearchIcon color="var(--color-main)" />
                </InputRightElement>
              </InputGroup>
              <Flex
                alignItems={"center"}
                gap={{ base: "16px 32px" }}
                flex={"1"}
                flexWrap={"wrap"}
                w={"100%"}
              >
                <Menu>
                  <MenuButton
                    _active={{
                      border: "1px solid var(--color-option-employee-hover)",
                    }}
                    _hover={{
                      boxShadow: "none",
                    }}
                    h={"44px"}
                    as={Button}
                    rightIcon={<ChevronDownIcon color={"#000"} />}
                    w="200px"
                    backgroundColor="#FFF"
                    border={"1px solid var(--Line)"}
                  >
                    <Text
                      textAlign={"start"}
                      color={"#000"}
                      fontSize={"14px"}
                      fontWeight={500}
                      whiteSpace="nowrap"
                      overflow="hidden"
                      textOverflow="ellipsis"
                    >
                      Chọn hành động
                    </Text>
                  </MenuButton>
                  <MenuList
                    fontSize={{ base: "14px" }}
                    fontWeight={500}
                    lineHeight={"140%"}
                    color={"var(--color-info-employee)"}
                  >
                    <MenuItem
                      gap={"16px"}
                      onClick={onAppoveRegisterRelativeStatus}
                    >
                      Duyệt thông tin nhân viên tham gia giao dịch
                    </MenuItem>
                    <MenuItem
                      gap={"16px"}
                      mt={"10px"}
                      onClick={onAppoveInfoStatus}
                    >
                      Duyệt thông tin giao dịch
                    </MenuItem>
                  </MenuList>
                </Menu>
                {/* <SearchableSelectMulti
                isShowSearch={false}
                options={statusDatas}
                // initialSelectedOption={{
                //   key: null,
                //   value: "Trạng thái locking",
                // }}
                placeholder={"Trạng thái locking"}
                setValue={setStatus}
              /> */}
                {/* <SearchableSelect
                  // isShowSearch={true}
                  options={GetTtkqHdmbs}
                  initialSelectedOption={{
                    key: 0,
                    value: "Trạng thái lên TTKQ/HĐMB",
                  }}
                  setValue={setIsTtkqHdmbs}
                /> */}
                <SearchableSelect
                  isShowSearch={true}
                  options={approveTransactions}
                  initialSelectedOption={{
                    key: 0,
                    value: "Chọn giao dịch đã duyệt",
                  }}
                  setValue={setApproveTransaction}
                  width={"225px"}
                />
              </Flex>
            </Flex>
          </Flex>
          <Box width={"100%"} height={"100%"}>
            {/* Header + hàng bộ lọc luôn hiển thị; chỉ hiện Skeleton ở vùng dữ liệu khi tải/refetch */}
            <>
              <TableContainer
                w={"100%"}
                maxH="calc(100vh - 350.5px)"
                overflowY="auto"
              >
                <Table w={"100%"} variant="unstyled">
                  <Thead
                    position="sticky"
                    top="0"
                    zIndex="1"
                    w={"100%"}
                    h={"41px"}
                    color="white"
                    fontWeight="400"
                    backgroundColor="#F9FAFD"
                  >
                    <Tr h={{ base: "41px" }}>
                      <Td>
                        <Checkbox
                          size={"lg"}
                          gap={"24px"}
                          fontSize={"14px"}
                          lineHeight={"17px"}
                          fontWeight={"500"}
                          w={"100%"}
                          borderRadius={"8px"}
                          onChange={() => handleCheckboxDeleteAll(currentPage)}
                          isChecked={selectDeleteAll?.includes(currentPage)}
                        ></Checkbox>
                      </Td>

                      {tableData.headers.map((e, index) => {
                        let width = "auto";
                        let textAlign = "auto";
                        if (e.key === "") {
                          width = "2%";
                          textAlign = "center";
                        } else if (e.key === "code") {
                          width = "5%";
                          textAlign = "start";
                        } else if (e.key === "stepCommission") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "status") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "calculateServiceFees") {
                          width = "20%";
                          textAlign = "start";
                        } else if (e.key === "nameProject") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "saleOpeningEvent") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "booking") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "note") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "codeApartment") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "nameApartment") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "codeProduct") {
                          width = "10%";
                          textAlign = "start";
                        } else if (
                          e.key === "timeDelivery" ||
                          e.key === "timeStart" ||
                          e.key === "timeEnd"
                        ) {
                          width = "5%";
                          textAlign = "end";
                        } else {
                          width = "10%";
                          textAlign = "end";
                        }
                        return (
                          <Td
                            p={"16px 16px 8px 16px"}
                            key={index}
                            border={"none"}
                            color={"#51607B"}
                            fontSize={{ base: "14px" }}
                            w={width}
                          >
                            <Box textAlign={"center"} fontWeight={"bold"}>{e.label}</Box>
                          </Td>
                        );
                      })}
                    </Tr>
                    <ColumnFilterRow
                      headers={tableData.headers}
                      filters={columnFilters}
                      leadingCells={1}
                      backgroundColor="#F9FAFD"
                    />
                  </Thead>
                  <Tbody w={"100%"} h={"100%"}>
                    {isLoading || isRefetching ? (
                      <Tr>
                        <Td colSpan={tableData.headers.length} p={"16px"}>
                          <Skeleton height="400px" borderRadius="8px" />
                        </Td>
                      </Tr>
                    ) : tableData.data?.length > 0 ? (
                      tableData.data?.map((e, rowIndex) => {
                        const items = { ...e };
                        delete items.id;
                        delete items.edit;
                        delete items.detail;
                        delete items.statusSalesContract;
                        delete items.registerRelativeStatus;
                        delete items.statusTtkq;
                        delete items.is_allow_ttkq;
                        const keyValues = Object.keys(items);
                        return (
                          <Tr key={rowIndex} h={"72px"}>
                            <Td>
                              <Checkbox
                                size={"lg"}
                                gap={"24px"}
                                fontSize={"14px"}
                                lineHeight={"17px"}
                                fontWeight={"500"}
                                w={"100%"}
                                borderRadius={"8px"}
                                onChange={() => handleCheckboxChange(e.id)}
                                isChecked={selectedValues.includes(e.id)}
                                // disabled={!e?.registerRelativeStatus}
                              ></Checkbox>
                            </Td>

                            {/* {e.value} */}
                            <Td p={"16px 16px 8px 16px"} w={"2%"}>
                              <Menu>
                                <MenuButton
                                  _hover={{ backgroundColor: "none" }}
                                  _active={{ backgroundColor: "none" }}
                                  background="none"
                                  as={Button}
                                >
                                  <AiOutlineMore fontSize={"20px"} />
                                </MenuButton>
                                <MenuList
                                  fontSize={{ base: "14px" }}
                                  fontWeight={500}
                                  lineHeight={"140%"}
                                  color={"var(--color-info-employee)"}
                                >
                                  <MenuItem
                                    gap={"16px"}
                                    onClick={() => handlePopup(false, e)}
                                  >
                                    <Image src={iconDetail} /> Xem chi tiết
                                  </MenuItem>

                                  {(
                                    <MenuItem
                                      gap={"16px"}
                                      onClick={() =>
                                        handleProvisionalInfoPopup(e)
                                      }
                                    >
                                      <Image src={iconDetail} /> Xem chi tiết
                                      phí dịch vụ tạm tính
                                    </MenuItem>
                                  )}
                                </MenuList>
                              </Menu>
                            </Td>
                            <Td p={"16px 16px 8px 16px"} w={"2%"}>
                              {rowIndex + 1}
                            </Td>
                            {keyValues.map((keyvalue, index) => {
                              let width = "auto";
                              let widthText = "100%";
                              let textAlign = "auto";
                              let whiteSpace = "inherit";
                              if (keyvalue === "") {
                                width = "2%";
                                textAlign = "center";
                              } else if (keyvalue === "code") {
                                width = "5%";
                                textAlign = "start";
                              } else if (keyvalue === "stepCommission") {
                                width = "15%";
                                textAlign = "start";
                              }else if (keyvalue === "status") {
                                width = "15%";
                                textAlign = "start";
                              } else if (keyvalue === "calculateServiceFees") {
                                width = "30%";
                                textAlign = "start";
                              } else if (keyvalue === "saleOpeningEvent") {
                                width = "15%";
                                textAlign = "start";
                              } else if (keyvalue === "booking") {
                                width = "15%";
                                textAlign = "start";
                              } else if (keyvalue === "note") {
                                width = "15%";
                                textAlign = "start";
                              } else if (keyvalue === "nameProject") {
                                width = "15%";
                                textAlign = "start";
                              } else if (keyvalue === "price") {
                                width = "10%";
                                textAlign = "end";
                              } else if (keyvalue === "bookingTime") {
                                width = "10%";
                                textAlign = "start";
                              } else if (keyvalue === "codeApartment") {
                                width = "10%";
                                textAlign = "start";
                              } else if (keyvalue === "nameApartment") {
                                width = "10%";
                                textAlign = "start";
                              } else if (
                                keyvalue === "estimatePriceOfCommission" ||
                                keyvalue === "priceOfCommission" ||
                                keyvalue === "price"
                              ) {
                                // Cột giá/số -> căn phải
                                width = "10%";
                                textAlign = "end";
                              } else {
                                // Mặc định (chữ, ngày...) -> căn trái
                                width = "10%";
                                textAlign = "start";
                                whiteSpace = "inherit";
                              }
                              return (
                                <Td
                                  p={"16px 16px 8px 16px"}
                                  w={width}
                                  key={index}
                                >
                                  <Box
                                    fontSize={{ base: "14px" }}
                                    lineHeight={"19.6px"}
                                    textAlign={"start"}
                                    fontWeight={500}
                                    color={"var(--color-info-employee)"}
                                    w={widthText}
                                    whiteSpace={whiteSpace}
                                    overflow="hidden"
                                    textOverflow="ellipsis"
                                    display="-webkit-box"
                                    sx={{
                                      WebkitLineClamp: "2",
                                      WebkitBoxOrient: "vertical",
                                    }}
                                  >
                                    {keyvalue === "status" ||
                                    keyvalue === "calculateServiceFees"
                                      ? formatTableValue(
                                          e[keyvalue],
                                          keyvalue,
                                          submitStatus,
                                          e.id,
                                          revertStatus,
                                          handleNavigateCaculatePage,
                                        )
                                      : formatTableValue(e[keyvalue], keyvalue)}
                                  </Box>
                                </Td>
                              );
                            })}
                          </Tr>
                        );
                      })
                    ) : (
                      <Tr>
                        <Td
                          colSpan={tableData.headers.length}
                          textAlign="center"
                          padding={"40px 0"}
                        >
                          Không có dữ liệu
                        </Td>
                      </Tr>
                    )}
                  </Tbody>
                </Table>
              </TableContainer>
            </>
            <Box mt={10} mr={5} mb={5} ml={5}>
              <Flex alignItems={"center"} justifyContent={"space-between"}>
                <Text>
                  Showing {startEntry} to {endEntry} of {entries} entries
                </Text>
                <HStack spacing={2} justify="flex-end">
                  <ReactPaginate
                    className="pagination-custom"
                    pageCount={totalPages}
                    pageRangeDisplayed={3}
                    marginPagesDisplayed={1}
                    onPageChange={handlePageChange}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                    breakClassName={"ellipsis"}
                    breakLabel={"..."}
                    previousLabel={
                      <Img
                        w={"16px"}
                        minW={"16px"}
                        h={"16px"}
                        src={chevronLeft}
                      />
                    }
                    nextLabel={
                      <Img
                        w={"16px"}
                        minW={"16px"}
                        h={"16px"}
                        src={chevronRight}
                      />
                    }
                    renderOnZeroPageCount={null}
                    forcePage={currentPage - 1}
                  />
                </HStack>
              </Flex>
            </Box>
          </Box>
        </Flex>
      </Flex>
      {isAddBooking ? (
        <FormDetail
          isOpen={isOpen}
          onClose={onClose}
          isEdit={true}
          defaultValues={dataEdit}
          onSubmit={onSubmitEdit}
        />
      ) : (
        <>
          <FormInfo
            isOpen={isOpen}
            onClose={onClose}
            defaultValues={dataEdit}
            refetch={refetch}
          />
          <FormProvisionalInfo
            isOpen={isOpenProvisionalInfo}
            onClose={onCloseProvisionalInfo}
            defaultValues={dataEdit}
            refetch={refetch}
          />
        </>
      )}
      <DeleteDialog
        isOpen={isOpenCloseAll}
        onClose={onCloseCloseAll}
        title="Duyệt thông tin nhân viên tham gia giao dịch"
        description={
          <Flex display={"inline"}>
            "Bạn có chắc chắn muốn duyệt thông tin nhân viên tham gia giao dịch
            của các sản phẩm và căn hộ có mã{" "}
            <Text fontWeight={"600"} display={"inline"}>
              {tableData?.data
                ?.filter((item) => selectedValues.includes(item.id))
                ?.map((item) => item.codeApartment)
                ?.join(", ")}
            </Text>{" "}
            này không?"
          </Flex>
        }
        textDelete={"Duyệt"}
        isDelete={false}
        action={() => appoveRegisterRelativeStatusAll()}
      />

      <DeleteDialog
        isOpen={isOpenInfoAll}
        onClose={onCloseInfoAll}
        title="Duyệt thông tin giao dịch"
        description={
          <Flex display={"inline"}>
            "Bạn có chắc chắn muốn duyệt thông tin giao dịch của các sản phẩm và
            căn hộ có mã{" "}
            <Text fontWeight={"600"} display={"inline"}>
              {tableData?.data
                ?.filter((item) => selectedValues.includes(item.id))
                ?.map((item) => item.codeApartment)
                ?.join(", ")}
            </Text>{" "}
            này không?"
          </Flex>
        }
        textDelete={"Duyệt"}
        isDelete={false}
        action={() => appovedInfoStatusAll()}
      />

      <DeleteDialog
        isOpen={isOpenMessage}
        onClose={closeMessage}
        title={"Thông tin duyệt"}
        description={
          <Flex flexDirection={"column"}>
            {message2 && (
              <>
                <Flex display={"inline"}>
                  Bạn chưa duyệt thông tin nhân viên tham gia tham gia giao dịch
                  của các căn: {message2}
                </Flex>
                <Button
                  size="sm"
                  colorScheme="blue"
                  leftIcon={<CopyIcon />}
                  onClick={onCopy2}
                  variant="outline"
                  mt={"6px"}
                  mb={"16px"}
                >
                  {hasCopied2 ? "Đã copy" : "Copy các căn hộ"}
                </Button>
              </>
            )}

            <Flex display={"inline"}>
              Bạn đã duyệt{" "}
              {actionSelected === 2
                ? "thông tin giao dịch"
                : "thông tin nhân viên tham gia giao dịch"}{" "}
              của các căn: {message}
            </Flex>
            <Button
              size="sm"
              colorScheme="blue"
              leftIcon={<CopyIcon />}
              onClick={onCopy}
              variant="outline"
              mt={"6px"}
            >
              {hasCopied ? "Đã copy" : "Copy căn hộ đã duyệt"}
            </Button>
          </Flex>
        }
        isNotification={true}
      />
    </>
  );
};

export default TableLocking;
